// @ts-nocheck
import { useEffect, useState } from 'react';

import { refreshSession } from '@/utilities/sessionRefresh';

export function useSessionRefresh(): number {
  const [version, setVersion] = useState(0);

  useEffect(() => {
    let alive = true;
    refreshSession().then((updated) => {
      if (alive && updated) setVersion((v) => v + 1);
    });
    return () => {
      alive = false;
    };
  }, []);

  return version;
}

export function useAclVersion(): number {
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const bump = () => setVersion((v) => v + 1);
    window.addEventListener('acl-refreshed', bump);
    return () => window.removeEventListener('acl-refreshed', bump);
  }, []);

  return version;
}
